import {createSlice} from '@reduxjs/toolkit';

export const paymentTabsSlice = createSlice({
  name: 'paymentTabs',
  initialState: {
    paymentTabs: ['QR', 'EMAIL']
  },
  reducers: {
    setPaymentTabs: (state, action) => {
      state.paymentTabs = action.payload;
    }
  }
});

export const {setPaymentTabs} = paymentTabsSlice.actions;
export default paymentTabsSlice.reducer;
